/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';
import { LG_SCREEN_MIN, MD_SCREEN_MIN } from '../../../../modules/Styleguide';
import { Button } from '../../../../shared/Button/NewButton';
import { CDN_PATH } from '../constants';
import { PageHeader, Section, SectionContent, SectionHeader } from '../styled';

export function ListenerSupportSection() {
  return (
    <React.Fragment>
      <StyledSection>
        <StyledSectionContent>
          <div
            css={css`
              grid-area: support;
            `}
          >
            <SectionHeader>Listener Support</SectionHeader>
            <p>
              Add a button to your Anchor profile that lets listeners sign up
              for monthly donations to help keep your podcast going. They don’t
              even need an Anchor account to chip in.
            </p>
          </div>
          <div
            css={css`
              grid-area: img;
            `}
          >
            <picture>
              <source
                type="image/webp"
                srcSet={`${CDN_PATH}/listener-support-img.webp`}
              />
              <img
                // @ts-ignore;
                loading="lazy"
                width="100%"
                alt="Anchor Payments tool"
                src={`${CDN_PATH}/listener-support-img.jpg`}
              />
            </picture>
          </div>
          <div
            css={css`
              grid-area: notice;
              @media (min-width: ${LG_SCREEN_MIN}px) {
                max-width: 300px;
              }
            `}
          >
            <DisclaimerText>
              We know podcasters are impacted by the world’s current
              circumstances, and we want to support everyone’s ability to earn
              money from their podcast. Beginning April 1, 2020, Anchor will be
              waiving its fee on Listener Support for six months. Creators who
              receive Listener Support payments during this time will get the
              4.5% Anchor fee returned straight to their Anchor wallet through
              September 30, 2020.
            </DisclaimerText>
          </div>
        </StyledSectionContent>
      </StyledSection>

      <div
        css={css`
          margin: 0 auto;
          text-align: center;
          background: white;
          position: relative;
        `}
      >
        <Section
          css={css`
            position: absolute;
            top: 30%;
            text-align: center;
          `}
        >
          <SectionContent
            css={css`
              color: white;
              flex-direction: column;
            `}
          >
            <PageHeader
              css={css`
                max-width: 420px;
                align-self: center;
                @media (min-width: ${MD_SCREEN_MIN}px) {
                  align-self: flex-start;
                  text-align: left;
                }
              `}
            >
              Ready to make your podcast?
            </PageHeader>
            <Button
              css={css`
                align-self: center;
                width: 210px;
                margin-top: 20px;
                @media (min-width: ${MD_SCREEN_MIN}px) {
                  align-self: flex-start;
                }
              `}
              href="/signup"
              color="aqua"
              kind="link"
            >
              Get Started
            </Button>
          </SectionContent>
        </Section>
        <picture>
          <source
            type="image/webp"
            srcSet={`${CDN_PATH}/anchor-get-started.webp`}
            media="(min-width: 600px)"
          />
          <source
            srcSet={`${CDN_PATH}/anchor-get-started.jpeg`}
            media="(min-width: 600px)"
          />
          <source
            type="image/webp"
            srcSet={`${CDN_PATH}/anchor-get-started-mobile.webp`}
          />
          <img
            css={css`
              min-height: 346px;
              overflow: hidden;
              width: 100%;
              max-width: 2547px;
            `}
            // @ts-ignore;
            loading="lazy"
            width="100%"
            alt="person holding a phone with Anchor's app displaying"
            src={`${CDN_PATH}/anchor-get-started-mobile.jpg`}
          />
        </picture>
      </div>
    </React.Fragment>
  );
}

const StyledSection = styled(Section)`
  background: white;
  padding-top: 75px;
  padding-bottom: 75px;

  @media (min-width: ${LG_SCREEN_MIN}px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`;

const StyledSectionContent = styled(SectionContent)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(auto-fill, minmax(100px, 1fr));
  grid-template-areas: 'img' 'support' 'notice';
  grid-gap: 20px;

  h1 {
    margin-bottom: 20px;
  }

  @media (min-width: ${MD_SCREEN_MIN}px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(auto-fill, minmax(100px, 1fr));
    grid-gap: 40px;
    grid-template-areas: 'support img' 'notice notice';
    p {
      max-width: 300px;
    }
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas: 'support img' 'notice img';
    p {
      max-width: 300px;
    }
  }
`;

const DisclaimerText = styled.span`
  font-size: 1.2rem;
`;
